import styled from 'styled-components';

export const CourierItemStyled = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;

  ${(props) =>
    props.$active
      ? `
      background-color: #F1F1F1;
  `
      : `
        &:hover {
          background-color: #F7F7F7;
        }
      `};
`;

export const CourierItemImageStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #e1e1e1;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
